import { HEADER_REFRESH_TOKEN } from '@/general/config'
import { lexonHttp } from '@/plugins/axios/lexonHttp'
import { FileManagerCreateFolder } from '@/store/modules/fileManager/fileManagerTypes'
import { useAuthStore } from '@/stores/auth/useAuthStore'

export const createFolder = async (props: FileManagerCreateFolder) => {
  const authStore = useAuthStore()

  const { data } = await lexonHttp.post('/file-manager/folder/create', props, {
    headers: {
      [HEADER_REFRESH_TOKEN]: authStore.refreshToken
    }
  })
  return data
}

export const uploadOrReplaceFile = async (formData: FormData, mode: string) => {
  const authStore = useAuthStore()
  const url = mode === 'replace' ? '/file-manager/file/replace' : '/file-manager/file/put'

  const { data } = await lexonHttp.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      [HEADER_REFRESH_TOKEN]: authStore.refreshToken
    }
  })
  return data
}
